###
# Provides UI for allowing the user to view/select table relationship paths
#
# selectable             (bool)   Signifies whether the paths are selectable vs read only
# selected               (object) An object with ``from``, ``to`` and ``name`` properties.
#                                 Modifying this will reflect in the checkboxes on the UI.
# tableId                (int)    Sets the table id used when filtering paths by table id.
# modalView              (bool)   Allow creating paths in modal or block view
# editingPath            (bool)   False by default, indicates if creating new path mode turn on/off
# referenceToLocalTable  (bool)   Used when filtering paths by table id. Only shows paths
#                                 where the table id is on the from/to direction of the path
###
angular.module('rjmNg.directives').directive "paths", [
  () ->
    restrict: "E"
    templateUrl: "directive.paths.html"
    replace: false
    scope: {
      selectable: '=?'
      selected: '=?'
      tableId: '=?'
      modalView: '=?'
      editingPath: '=?'
      referenceToLocalTable: '=?'
    }
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$scope"
      "$modal"
      "app"
      "StructureCache"
      "notification"
      "Clients"
      "$q"
      "$routeParams"
      "FEATURE_TIER"
      (
        $scope
        $modal
        app
        StructureCache
        notification
        Clients
        $q
        $routeParams
        FEATURE_TIER
      ) ->
        view = @
        view.editingPath = false
        view.clientId = $routeParams.clientId
        view.loading = true
        view.columnPaths = null
        view.filteredPaths = []
        view.structure = null
        view.selectedState = {}
        view.isAdminUser = app.isSupportUserSession() or app.isAdminUser()
        view.isSupportUser = app.isSupportUserSession()

        view.selectPath = (path) ->
          # select current path and uncheck previously selected path
          if view.selectedState[path.name]
            view.selected = path
          else # path is unchecked so no path should be selected
            view.selected = null

        view.filterTableId = (path) ->
          unless view.tableId?
            return true
          # Currently, same-table joins don't support in front-end, so hide same-table paths, when paths are selectable.
          _pathIsVisible = (path) ->
            return if view.selectable then path.to.table isnt path.from.table else true

          if view.referenceToLocalTable? and  view.referenceToLocalTable
            return path.to.table is view.tableId and _pathIsVisible(path)

          return path.from.table is view.tableId and _pathIsVisible(path)

        view.launchNewPathModal = () ->
          if view.modalView is true
            referenceScope = $scope.$new()
            referenceScope.tableId = view.tableId
            referenceScope.referenceToLocalTable = view.referenceToLocalTable

            modal = $modal
              template: 'modal.references.html'
              show: true
              backdrop: 'static'
              scope: referenceScope
              modalClass: 'wideModal'
          else
            view.editingPath = true

        view.setStructure = (structure) ->
          view.structure = structure
          StructureCache.getReferences().then( (result) ->
            view.columnPaths = angular.copy result.references
            view.loading = false
          , (error) ->
            notification.error("Server Error", "Error loading references.", "global")
            view.loading = false
          )

        $scope.$on 'structureCacheUpdated', () ->
          StructureCache.getStructureAndReferences().then(
            (result) ->
              view.setStructure(result.structure)
            , (error) ->
              notification.error("Server Error", "Error loading structure/references.", "global")
              view.loading = false
          )

        @$onInit = ->
          $q.all([StructureCache.getStructureAndReferences()
                  Clients.get(view.clientId)])
          .then ([structureAndReferences, clientInfo]) ->
            view.isEssentialsClient = clientInfo.properties?.feature_tier is FEATURE_TIER.BASIC.toString()
            view.setStructure(structureAndReferences.structure)
          .catch (error) ->
            notification.error("Server Error", "Error loading structure.", "global")
            view.loading = false

        view
    ]
    link: (scope, elem, attrs, rjmUi) ->
      view = scope.view
      scope.$watch "view.selected", (selectedPath) ->
        for pathName of view.selectedState
          view.selectedState[pathName] = false
        if selectedPath?
          view.selectedState[selectedPath.name] = true

      scope.$watch "view.loading", (loading) ->
        rjmUi?.loadingUi "paths", scope.view.loading
]
